import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { Avatar, Chip, EmptyState, PageTitle, Spinner } from '../components/ui'
import { cx } from '../lib/cx'
import { messageOf } from '../lib/api'
import { catBoardQuery } from '../lib/queries'

// The cats' all-time table (designs/20261028-cat-leaderboards.md). Nothing
// links here yet: Ryan opens it by URL until he decides where it belongs.
export const Route = createFileRoute('/l/$slug/cats')({ component: Cats })

function Cats() {
  const { slug } = Route.useParams()
  const q = useQuery(catBoardQuery(slug))
  if (q.isPending) return <div className="grid place-items-center py-16 text-muted"><Spinner /></div>
  if (q.isError) return <EmptyState title="Couldn't load the cats">{messageOf(q.error)}</EmptyState>
  const { cats, rounds_final } = q.data
  const rows = cats ?? []
  return (
    <>
      <PageTitle eyebrow="All seasons" aside={<Chip tone="done">{rounds_final === 1 ? '1 round scored' : `${rounds_final} rounds scored`}</Chip>}>
        Cats
      </PageTitle>
      {rows.length === 0 && <p className="text-[14.5px] text-muted">No cat is on the board until a round is scored.</p>}
      {rows.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse tabular-nums">
            <thead>
              <tr className="text-left text-[11px] font-semibold uppercase tracking-[.1em] text-muted">
                <th className="w-9 pb-2 pl-2" />
                <th className="pb-2 pl-2">Cat</th>
                <th className="pb-2 pr-2 text-right">Posts</th>
                <th className="pb-2 pr-2 text-right">Wins</th>
                <th className="pb-2 pr-3 text-right">Votes</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.pet.id} className={cx('border-t border-line', r.is_mine && 'bg-accent-wash')}>
                  <td className={cx('py-2.5 pl-2 font-score text-[22px] font-bold text-muted', r.is_mine && 'rounded-l-field')}>{r.rank}</td>
                  <td className="py-2.5 pl-2 text-[15px]">
                    <span className="flex items-center gap-2.5">
                      <Avatar src={r.pet.photo_url} kind="cat" />
                      <span className="min-w-0">
                        <b className="block truncate font-semibold">{r.pet.name}</b>
                        <span className="block truncate text-[12.5px] text-muted">{(r.managers ?? []).map((m) => m.display_name).join(', ')}</span>
                      </span>
                    </span>
                  </td>
                  <td className="py-2.5 pr-2 text-right text-[14.5px]">{r.posts}</td>
                  <td className="py-2.5 pr-2 text-right text-[14.5px]">{r.wins}</td>
                  <td className={cx('py-2.5 pr-3 text-right font-score text-[24px] font-bold', r.is_mine && 'rounded-r-field')}>{r.votes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p className="text-[13px] text-muted">Votes the cat's posts received, all seasons. A post with two cats counts for both.</p>
    </>
  )
}
